import { render, staticRenderFns } from "./List.vue?vue&type=template&id=d51caf00&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"
import style0 from "./List.vue?vue&type=style&index=0&id=d51caf00&prod&scoped=true&lang=css"
import style1 from "./List.vue?vue&type=style&index=1&id=d51caf00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d51caf00",
  null
  
)

export default component.exports